import React from "react";
import Navbar from "./components/Navbar";
import About from "./components/About";
import Bio from "./components/Bio";
import Publications from "./components/Publications";
import ProfessionalExperience from "./components/ProfessionalExperience";
import AcademicExperience from "./components/AcademicExperience";
import Awards from './components/Awards';
import Resume from "./components/Resume";
import Footnote from "./components/Footnote";
import "./styles.css";

const App = () => (
  <div className="App">
    <Navbar />
    <div className="site-shell">
      <aside className="profile-column">
        <About />
      </aside>
      <main className="content-column">
        <Bio />
        <Publications />
        <ProfessionalExperience />
        <AcademicExperience />
        <Awards />
        <Resume />
        <Footnote />
      </main>
    </div>
  </div>
);

export default App;
